<div class="assessment-container">
  <assessment-row title="Urine Color" [historyMode]="true">
    <p>{{ data().urineColor }}</p>
  </assessment-row>

  <assessment-row title="Urine Characteristics" [historyMode]="true">
    <emr-list [list]="data().urineCharacteristics" emptyText="N/A"></emr-list>
  </assessment-row>

  <assessment-row title="Urinary Pattern" [historyMode]="true">
    <emr-list [list]="data().urinaryPattern" emptyText="N/A"></emr-list>
  </assessment-row>

  @if (patient().isPediatric()) {
  <assessment-row title="Abnormal Testes?" [historyMode]="true">
    <p>{{ data().abnormalTestes ? "Yes" : "No" }}</p>
  </assessment-row>
  @if (data().abnormalTestes) {
  <assessment-row title="Testes Abnormality Details" [historyMode]="true">
    <p>{{ data().testesAbnormalityDetails }}</p>
  </assessment-row>
  }
  <assessment-row title="Abnormal Vaginal Opening?" [historyMode]="true">
    <p>{{ data().abnormalVaginalOpening ? "Yes" : "No" }}</p>
  </assessment-row>
  @if (data().abnormalVaginalOpening) {
  <assessment-row title="Vaginal Opening Abnormality Details" [historyMode]="true">
    <p>{{ data().vaginalOpeningAbnormalityDetails }}</p>
  </assessment-row>
  }
  }

  <h2>Foley</h2>

  <assessment-row title="Justification" [historyMode]="true">
    <p>{{ data().foleyJustification }}</p>
  </assessment-row>

  <assessment-row title="Securement" [historyMode]="true">
    <p>{{ data().foleySecurement }}</p>
  </assessment-row>

  @if (patient().isObstetric()) {
  @if (data().hasAbnormalLochia) {
  <h2>Abnormal Lochia</h2>
  <assessment-row title="Inappropriate Color?" [historyMode]="true">
    <p>{{ data().abnormalLochiaHasInappropriateColor | booleanToYesNo }}</p>
  </assessment-row>
  <assessment-row title="Heavy Bleeding?" [historyMode]="true">
    <p>{{ data().abnormalLochiaHasHeavyBleeding | booleanToYesNo }}</p>
  </assessment-row>
  <assessment-row title="Foul Odor?" [historyMode]="true">
    <p>{{ data().abnormalLochiaHasFoulOdor | booleanToYesNo }}</p>
  </assessment-row>
  <assessment-row title="Other" [historyMode]="true">
    <p>{{ data().abnormalLochiaOther }}</p>
  </assessment-row>
  }

  @if (data().hasAbnormalUterine) {
  <h2>Abnormal Uterine Assessment</h2>
  <assessment-row title="Fundal Location" [historyMode]="true">
    <p>{{ data().abnormalUterineFundalLocation }}</p>
  </assessment-row>
  <assessment-row title="Fundal Feel" [historyMode]="true">
    <p>{{ data().abnormalUterineFundalFeel }}</p>
  </assessment-row>

  @if (data().areContractionsPresent) {
  <h3>Contractions</h3>
  <assessment-row title="Contraction Strength" [historyMode]="true">
    <p>{{ data().contractionsStrength }}</p>
  </assessment-row>
  <assessment-row title="Contraction Duration" [historyMode]="true">
    <p>{{ data().contractionsDuration }}</p>
  </assessment-row>
  <assessment-row title="Contraction Frequency" [historyMode]="true">
    <p>{{ data().contractionsFrequency }}</p>
  </assessment-row>
  }
  }

  @if (data().hasFetalHeartTones) {
  <h2>Fetal Heart Tones Present</h2>
  <assessment-row title="Accelerations Noted" [historyMode]="true">
    <p>{{ data().fetalHeartTonesAccelerationsNoted }}</p>
  </assessment-row>
  <assessment-row title="Decelerations Noted" [historyMode]="true">
    <p>{{ data().fetalHeartTonesDecelerationsNoted }}</p>
  </assessment-row>
  <assessment-row title="FHT Variability" [historyMode]="true">
    <p>{{ data().fetalHeartTonesVariability }}</p>
  </assessment-row>
  }

  @if (data().hasAbnormalVaginalAssessment) {
  <h2>Abnormal Vaginal Assessment</h2>
  <assessment-row title="Episiotomy" [historyMode]="true">
    <p>{{ data().abnormalVaginalEpisiotomy }}</p>
  </assessment-row>
  <assessment-row title="Tear" [historyMode]="true">
    <p>{{ data().abnormalVaginalTear }}</p>
  </assessment-row>
  <assessment-row title="Dilation" [historyMode]="true">
    <p>{{ data().abnormalVaginalDilation }}</p>
  </assessment-row>
  <assessment-row title="Station" [historyMode]="true">
    <p>{{ data().abnormalVaginalStation }}</p>
  </assessment-row>
  }
  }

  <assessment-row title="Other Findings" [historyMode]="true">
    <p>{{ data().otherFindings }}</p>
  </assessment-row>
</div>